import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import SideBar from "../SideBar/SideBar";
import "./About.css";

export default function About(props) {
  return (
    <Container className="h-100 bg-dark" id="about" fluid>
      <Row className="h-100">
        <div className="d-none d-md-block col-md-1">
          <SideBar active="About" />
        </div>
        <div className="col-md text-light mt-5 about-me-details">
          <h2 className="mt-3 mt-md-5 mb-md-4">
            <span className="text-danger">About</span> me
          </h2>
          <h6 className="mt-2">
            <span style={{ textIndent: "1rem" }}>
              I am a full stack developer who has worked with NodeJS with
              ExpressJS & Serverless Framework, Java for backend and for
              front-end React & Angular. I am also an enthusiast for mobile
              application development for which I usually use React Native and
              currently learning about Flutter.
            </span>
            <span className="d-block d-md-none">
              Below are my skills mentioned
            </span>
          </h6>
          <h6 className="mt-2 d-none d-md-block" style={{ textIndent: "1rem" }}>
            Currently, I am working as a Full Stack Web Developer at Cognizant
            Technology Solutions, where I use NodeJS with Serverless Framework,
            Angular and AWS for cloud development. On the left side mentioned
            are my skills
          </h6>
          <div className="d-block d-md-none">
            <div className="row mt-5 justify-content-md-center">
              <h6 className="col-4">Angular/React</h6>
              <div className="col-8">
                <progress min="0" max="100" value="92" />
              </div>
            </div>
            <div className="row justify-content-md-center">
              <h6 className="col-4">HTML & CSS</h6>
              <div className="col-8">
                <progress min="0" max="100" value="90" />
              </div>
            </div>
            <div className="row justify-content-md-center">
              <h6 className="col-4">Java</h6>
              <div className="col-8">
                <progress min="0" max="100" value="93" />
              </div>
            </div>
            <div className="row justify-content-md-center">
              <h6 className="col-4">NodeJS</h6>
              <div className="col-8">
                <progress min="0" max="100" value="85" />
              </div>
            </div>
            <div className="row justify-content-md-center">
              <h6 className="col-4">AWS Cloud</h6>
              <div className="col-8">
                <progress min="0" max="100" value="82" />
              </div>
            </div>
            <div className="row justify-content-md-center">
              <h6 className="col-4">Python</h6>
              <div className="col-8">
                <progress min="0" max="100" value="85" />
              </div>
            </div>
            <div className="row justify-content-md-center">
              <h6 className="col-4">PHP</h6>
              <div className="col-8">
                <progress min="0" max="100" value="60" />
              </div>
            </div>
            <div className="row justify-content-md-center">
              <h6 className="col-4">JavaScript</h6>
              <div className="col-8">
                <progress min="0" max="100" value="90" />
              </div>
            </div>
            <div className="row justify-content-md-center">
              <h6 className="col-4">UI/UX</h6>
              <div className="col-8">
                <progress min="0" max="100" value="80" />
              </div>
            </div>
          </div>
          <Col className="d-flex justify-content-center d-block d-md-none">
            <Link className="text-light" to="/projects">
              <i className="mt-5 fa-2x fa-solid fa-angles-down"></i>
            </Link>
          </Col>
        </div>
        <div className="col-md-4 d-none d-md-block text-light bg-danger">
          <div className="row mt-4"></div>
          <div className="row mt-5 pt-5 justify-content-md-center">
            <h6 className="col-4">Angular</h6>
            <div className="col-8">
              <progress min="0" max="100" value="92" />
            </div>
          </div>
          <div className="row justify-content-md-center">
            <h6 className="col-4">Serverless</h6>
            <div className="col-8">
              <progress min="0" max="100" value="86" />
            </div>
          </div>
          <div className="row justify-content-md-center">
            <h6 className="col-4">HTML & CSS</h6>
            <div className="col-8">
              <progress min="0" max="100" value="90" />
            </div>
          </div>
          <div className="row justify-content-md-center">
            <h6 className="col-4">React</h6>
            <div className="col-8">
              <progress min="0" max="100" value="86" />
            </div>
          </div>
          <div className="row justify-content-md-center">
            <h6 className="col-4">ExpressJS</h6>
            <div className="col-8">
              <progress min="0" max="100" value="85" />
            </div>
          </div>
          <div className="row justify-content-md-center">
            <h6 className="col-4">Java</h6>
            <div className="col-8">
              <progress min="0" max="100" value="83" />
            </div>
          </div>
          <div className="row justify-content-md-center">
            <h6 className="col-4">AWS Cloud</h6>
            <div className="col-8">
              <progress min="0" max="100" value="82" />
            </div>
          </div>
          <div className="row justify-content-md-center">
            <h6 className="col-4">Python</h6>
            <div className="col-8">
              <progress min="0" max="100" value="85" />
            </div>
          </div>
          <div className="row justify-content-md-center">
            <h6 className="col-4">PHP</h6>
            <div className="col-8">
              <progress min="0" max="100" value="60" />
            </div>
          </div>
          <div className="row justify-content-md-center">
            <h6 className="col-4">JavaScript</h6>
            <div className="col-8">
              <progress min="0" max="100" value="90" />
            </div>
          </div>
          <div className="row justify-content-md-center">
            <h6 className="col-4">UI/UX</h6>
            <div className="col-8">
              <progress min="0" max="100" value="80" />
            </div>
          </div>
          <Link className="mt-5 pt-5 text-light" to="/projects" id="arrow-down">
            <i className="mt-5 pt-5 fa-2x fa-solid fa-angles-down"></i>
          </Link>
        </div>
      </Row>
    </Container>
  );
}
